<template>
  <div>
    <div class="info_box">
      <div class='vxreset'>
        <input type='text' placeholder='请输入手机号' :class="'log-input' + (account==''?' log-input-empty':'')" name='account' v-model='account'>
      </div>
       <div class="vxreset">
         <div class="get_code_box">
           <div class="left_input">
             <input type='text' placeholder='短信验证码' @blur="judgeInfo()" class="code" v-model='ver_code'>
           </div>
           <span class="get_code" v-if='getting'>{{ get_time }}s</span>
           <span class="get_code" v-else @click="getVerCode()">获取验证码</span>
         </div>
         <!-- <div class="tip" v-if="code_tip">请输入正确的验证码</div> -->
      </div>
      <div class="info_tip" :class="{'hidden-footer': hiddenFooter}">
        <span v-if="tipInfo !==''"></span>
        <p>{{tipInfo}}</p>
      </div>
    </div>

    <div class='btn_box' :class="{'hidden-footer': hiddenFooter}">
      <span class='confirm' @click="login()">登 录</span>
    </div>
    <div class="other_box" v-if="!hiddenFooter">
      <span @click="forgetShow()">忘记密码？</span>
      <p>没有账号？请<span @click="regShow()"> 注册</span></p>
    </div>
  </div>
</template>

<script>
/**
 * @description Copy from /src/components/common/Login
 */

export default {
  name: 'LoginDQForm',
  data () {
    return {
      getting: false,
      account: '',
      ver_code: '',
      tipInfo: '',
      code_tip: false,
      click: true,
      formData: {},
      get_time: 60
    }
  },
  props: {
    hiddenFooter: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    regShow () {
      this.$store.dispatch('change_reg_show', true)
      this.resetField()
    },
    forgetShow () {
      this.$store.dispatch('change_forget_show', true)
      this.resetField()
    },
    resetField () {
      this.account = ''
      this.tipInfo = ''
      this.click = true
      this.formData = {}
    },
    getVerCode () {
      if (!this.verifyPhoneNum()) {
        return
      }
      this.get_time = 60
      this.getting = true
      var authTimetimer = setInterval(() => {
        this.get_time--
        if (this.get_time <= 0) {
          this.getting = false
          clearInterval(authTimetimer)
        }
      }, 1000)
      var formData = {
        account: this.account,
        type: 'phone',
        use: 5
      }
      this.axios.post('/api/interface/account/send_verification_code', formData).then(res => {
        if (res.data.state === 0) {
          this.tipInfo = ''
        } else {
          if (res.data.state === 1) {
            this.tipInfo = res.data.msg
          }
        }
      })
    },
    verifyPhoneNum () {
      var phPattern = /^1(3\d|4[5-9]|5[0-35-9]|6[2567]|7[0-8]|8\d|9[0-35-9])\d{8}$/
      if (!phPattern.test(this.account)) {
        this.tipInfo = '请输入正确格式的手机号'
      }
      return phPattern.test(this.account)
    },
    login () {
      if (!this.verifyPhoneNum()) {
        return
      }
      this.toLogin()
    },
    toLogin () {
      if (this.click) {
        this.click = false
        this.$emit('loading', true)
        this.formData['account'] = this.account
        this.formData['type'] = 'pc'
        this.formData['captcha'] = this.ver_code
        this.formData['login_type'] = 'phone'
        this.axios.post('/api/interface/login', this.formData).then(res => {
          if (res) {
            this.$emit('loading', false)
            if (res.data.state === 0) {
              this.$store.commit('SET_BASEINFO', {account: this.account, token: res.data.token, id: res.data.uid, is_first: res.data.is_first, is_bind: res.data.is_bind})
              this.setCookie(res.data.token, 30)
              setTimeout(() => {
                window.location.reload()
              })
            } else {
              this.tipInfo = res.data.msg
            }
            this.click = true
          }
        })
      }
    },
    // 设置cookie
    setCookie (token, exdays) {
      var exdate = new Date() // 获取时间
      exdate.setTime(exdate.getTime() + 24 * 60 * 60 * 1000 * exdays) // 保存的天数
      // 字符串拼接cookie
      window.document.cookie = 'Access-Token' + '=' + token + ';path=/;expires=' + exdate.toGMTString()
    },
    judgeInfo () {
      this.code_tip = this.ver_code === ''
    }
  }
}
</script>

<style lang="less" scoped  rel="stylesheet/less">
.vip_icon{
  margin: 20px auto;
  text-align: center;
  img{
    width: 182px;
    height: 59px;
  }
}
.info_box{
  padding: 0 25px;
  .last{
    padding-bottom: 0!important;
  }
  .vxreset {
    padding-bottom: 17px;
    text-align: center;
    clear: both;
    height: 45px;
    position: relative;
    .get_code_box {
      display: flex;
      .left_input {
        flex: 1;
      }
    }
    input {
      background-color: #fff;
      border: 1px solid #c5c5c5;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      color: #1f2d3d;
      height: 45px;
      padding: 0 10px 0 10px;
      -webkit-transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
      transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
      float: left;
      width: 100%;
      font-size: 16px;
      border-radius: 5px;
      &:focus {
        border-color: #d1434a;
      }
    }
     .get_code{
       cursor: pointer;
       display: block;
       width: 116px;
       line-height: 43px;
       float: left;
       margin-left: 10px;
       font-size: 14px;
       color: #fff;
       letter-spacing: 1px;
       background: url("../../../static/img/common/code_btn.png")no-repeat;
     }
  }
  .info_tip{
    position: relative;
    padding: 10px 10px 10px 20px;
    height: 15px;
    &.hidden-footer {
      height: 21px;
    }
    span{
      display: block;
      width: 14px;
      height: 14px;
      background: url("../../../static/img/user_center/default_icon.png")no-repeat;
      position: absolute;
      left: 1px;
    }
    p{
      font-size: 12px;
      line-height: 14px;
      color: #d1434a;
      text-align: left;
    }
  }
}
.btn_box{
  width: 100%;
  height: 60px;
  .confirm{
    cursor: pointer;
    display: block;
    width: 355px;
    margin: 0 auto;
    height: 100%;
    line-height: 60px;
    color: #fff;
    background: url("../../../static/img/common/btn_bg.png")no-repeat;
  }
  &.hidden-footer {
    padding-bottom: 58px;
  }
}
.other_box{
  display: table;
  padding-bottom:30px;
  text-align: center;
  width: 100%;
  font-size: 18px;
  color: #4f4f4f;;
  letter-spacing: 1px;
  margin-top: 43px;
  span{
    cursor: pointer;
    &:hover{
      color: #d1434a;
    }
  }
  p{
    padding: 0 43px;
    margin-top: 16px;
    span{
      color: #d1434a;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/PhoneCodeForm.vue